export const LEGAL = {
  razon: "Acta Non Verba Asesores, S.L.",
  marca: "ANV Asesores",
  cif: "B-88700836",
  domicilio: "Avinguda l'Aragai, 21, 08800 Vilanova i la Geltrú, Barcelona",
  registro: "Registro Mercantil de Barcelona, Hoja B-660630, Tomo 1000476948790, Folio 1, Inscripción 1",
  email: "info@anvasesores.es",
  telefono: "689 183 582",
  updated: "junio de 2026",
};

export function LegalPage({ title, subtitle, children }) {
  return (
    <div className="max-w-4xl mx-auto px-6 md:px-12 py-24" data-testid="legal-page">
      <div className="text-xs uppercase tracking-[0.32em] text-[#D4AF37] mb-6">{subtitle}</div>
      <h1 className="font-serif text-4xl md:text-5xl text-white leading-tight mb-4">{title}</h1>
      <p className="text-zinc-500 text-sm mb-12">Última actualización: {LEGAL.updated}</p>
      <div className="space-y-8 text-zinc-300 leading-relaxed">{children}</div>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section className="space-y-3">
      <h2 className="font-serif text-xl md:text-2xl text-white">{title}</h2>
      <div className="space-y-3 text-zinc-400 text-[15px] leading-relaxed">{children}</div>
    </section>
  );
}
